import { render, staticRenderFns } from "./common-poster-exact.vue?vue&type=template&id=0a883745&scoped=true&"
import script from "./common-poster-exact.vue?vue&type=script&lang=js&"
export * from "./common-poster-exact.vue?vue&type=script&lang=js&"
import style0 from "./common-poster-exact.vue?vue&type=style&index=0&id=0a883745&lang=scss&scoped=true&"
import style1 from "./common-poster-exact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a883745",
  null
  
)

export default component.exports